export default "__VITE_ASSET__c63ddd02__"